import FilterType from './filterType';
import valueIn from '../../utils/valueIn';

export default FilterType({
    id: 'SEGMENTS',
    filterFunction: (allHotelIds, filterTree, currentFilterValues, segmentationState, filterId) => {
    // NB: A checkbox will output MATCH as the OR of its individual segment matches (but not found in BLOCK)
    // NB: A checkbox will output BLOCK as the NOR of its individual segment matches
    // NB: A checkbox will output potentials as EVERYTHING not found BLOCK
        const bucketLookup = {};
        let isFilterActive = false;
        let activeFilterOptionsCount = 0;

    // TODO: This can be improved since basically all we do is merge bucket lists...
        if (!allHotelIds || !filterTree || !currentFilterValues || !segmentationState || !filterId) {
            return 0;
        }

        currentFilterValues.forEach((filterValue, key) => {
            const value = valueIn(filterValue, 'value');
            if (value) {
                isFilterActive = true;
                ++activeFilterOptionsCount;

                const bucket = valueIn(filterTree, [filterId, key]) || [];

        // TODO: Maybe we should store these as lookups in the filtertree directly?
                bucket.forEach((hotelId) => {
                    bucketLookup[hotelId] = true;
                });
            }
        });

    // NB: If we do not have an activeFilter, there is no further work to do here, abort
        if (!isFilterActive) {
            return 0;
        }

        const currentFilterBlocks = [];

        allHotelIds.forEach((hotelId) => {
            if (bucketLookup[hotelId]) {
                segmentationState.match[hotelId] = !segmentationState.block[hotelId];
            } else {
                currentFilterBlocks.push(hotelId);
            }
        });


        const currentFilterPotentials = {};

        currentFilterBlocks.forEach((hotelId) => {
            Object.keys(segmentationState.potentials).forEach((filterId) => {
                if (segmentationState.potentials[filterId][hotelId]) {
                    segmentationState.potentials[filterId][hotelId] = false; // This filter blocks another filters potential
                }
            });

            if (!segmentationState.block[hotelId]) {
                currentFilterPotentials[hotelId] = true;
            }

            segmentationState.block[hotelId] = true;
            segmentationState.match[hotelId] = false; // TODO: is this even needed?

        });

        segmentationState.potentials[filterId] = currentFilterPotentials;

        return activeFilterOptionsCount;
    }
});
